import React, { Children, useEffect, useState } from 'react'
import Popup from 'reactjs-popup'
import Icon from 'srcReact/components/icons/Icon'
import Button from '../Button'
import styles from './styles.module.scss'

export default function MobileModal({
  showBackArrow = true,
  className,
  children,
  isOpen,
  title,
  subTitle,
  titleCSS,
  customContentStyle,
  nested = true,
  handleClose,
  closeOnDocumentClick = false,
  showDefaultHeader = true,
  headerCSS,
  draggableDivCSS,
  backCSS,
  showOptions = false,
  optionsChildren,
  optionsCSS,
  showDraggableDiv = true,
  ...rest
}) {
  const [touchStart, setTouchStart] = React.useState(0)
  const [touchEnd, setTouchEnd] = React.useState(0)
  const [isSwipe, setIsSwipe] = useState(false)
  const [slideDown, setSlideDown] = useState(false)
  useEffect(() => {
    setSlideDown(false)
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const contentStyle = {
    position: 'absolute',
    bottom: '0',
    borderRadius: '1.25rem',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    padding: '0.5rem',
    paddingBottom: '1.5rem',
    background: '#fff',
    width: '100%',
    overflow: 'auto',
    boxShadow: '0 2px 6px 1px rgba(0, 0, 0, 0.1)',
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
  const contentWidth = {
    maxHeight: '100vh'
  }
  const finalContentWidth = customContentStyle ? customContentStyle : contentWidth

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientY)
  }
  const handleTouchEnd = (e) => {
    if (isSwipe) {
      if (touchEnd - touchStart < 100) {
        // do your stuff here for right swipe
        closeModal()
      }
      setIsSwipe(false)
    }
  }
  const handleTouchMove = (e) => {
    setIsSwipe(true)
    setTouchEnd(e.targetTouches[0].clientY)
  }

  const closeModal = () => {
    setSlideDown(true)
    handleClose()
    setSlideDown(false)
  }

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <Popup
      className={slideDown ? `mobileModalDown_${className}` : `mobileModalUp_${className}`}
      contentStyle={{ ...contentStyle, ...finalContentWidth }}
      nested={nested}
      lockScroll
      open={isOpen}
      onClose={closeModal}
      closeOnDocumentClick={closeOnDocumentClick}
      closeOnEscape={true}
      {...rest}>
      {showDefaultHeader && (
        <header
          className={`${styles.header} ${headerCSS}`}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}>
          {showBackArrow && (
            <div role='button' className={`${styles.backButton} ${backCSS}`} onClick={closeModal}>
              <Icon name='arrow-left24' />
            </div>
          )}

          {showDraggableDiv && <div className={`${styles.draggableDiv} ${draggableDivCSS}`}></div>}
          {showOptions && <div className={`${styles.options} ${optionsCSS}`}>{optionsChildren}</div>}
        </header>
      )}
      {title && <h1 className={`${styles.title} ${titleCSS}`}>{title}</h1>}
      {subTitle && <h2 className={styles.subTitle} dangerouslySetInnerHTML={{ __html: subTitle }} />}
      {children}
    </Popup>
  )
}
